<ion-header>
  <ion-toolbar>

    <ion-back-button color="dark" slot="start" defaultHref="/home" text="" icon="chevron-back"></ion-back-button>

    <ion-title>
      <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData && dataServ.rData.dark_logo[0]; else textHeader"></ion-img>
      <ng-template #textHeader>
        <ion-text color="dark" class="ion-text-center">
          <h1>{{"FAQ" | caption | translate}}</h1>
        </ion-text>
      </ng-template>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid class="content-grid">

    <ion-row>
      <ion-col size="12">
        <div class="safe-area"></div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-list>
          <ng-container *ngFor="let question of dataServ.rData.title_and_descriptions; let i = index">
            <ion-item *ngIf="question.title | caption | translate" (click)="displays[i] = displays[i] ? false : true">
              <ion-icon slot="start" [name]="displays[i] ? 'chevron-up' : 'chevron-down'"></ion-icon>
              <ion-label text-wrap>
                <h5><b>
                    {{question.title | caption | translate}}
                  </b></h5>

                <p *ngIf="displays[i]" [innerHTML]="question.description | caption | translate">
                </p>
              </ion-label>
            </ion-item>
          </ng-container>
        </ion-list>
      </ion-col>
    </ion-row>

  </ion-grid>

</ion-content>